import React, { Component } from 'react';

import StatsHeader from '../../components/stats/header';
import StatsMain from '../../components/stats/main';

import style from './index.module.scss';

class StatsPage extends Component {
  state = {
    categoryOption: 'answers',
    periodOption: '7 days',
  };

  onPeriodSelect = option =>
    this.setState({
      periodOption: option.value,
    });

  onCategorySelect = option =>
    this.setState({
      categoryOption: option.value,
    });

  render() {
    const { categoryOption, periodOption } = this.state;

    return (
      <div className={style.stats}>
        <StatsHeader
          categoryOption={categoryOption}
          periodOption={periodOption}
          handlePeriodSelect={this.onPeriodSelect}
          handleCategorySelect={this.onCategorySelect}
        />
        <StatsMain
          periodOption={periodOption}
          categoryOption={categoryOption}
        />
      </div>
    );
  }
}

export default StatsPage;
